import { gql } from '@apollo/client';
const REMOVE_PRODUCT_FUNCTION = gql `
  mutation RemoveProductFunction($productFunctionId: ID!) {
    removeProductFunction(productFunctionId: $productFunctionId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_FUNCTION;
